// extracted by mini-css-extract-plugin
export default {"apps":"AccountApps_apps__mD7-P","title":"AccountApps_title__AyumS"};